"use strict";

import React from 'react';
import AccountAddressForm from "../../account/component/AccountAddressForm";
import SaveCancelButtons from "../../component/SaveCancelButtons";
import Icon from "../../component/Icon";
import {useHistory} from "react-router-dom";
import AccountAddressFormBundle from "../../account/component/AccountAddressFormBundle";

const AccountSettingAddresses = ({account={}, address= {}, onUpdateAddress=()=>{},}) => {
    const history = useHistory();

    function handleAddressFormSubmit(data={}){
        const {address_id:id=0} = address;
        onUpdateAddress(id, data);
    }

    function handleAddressFormCancel(e={},){
        e.preventDefault();
        history.push('/echeck/accounts/settings/');
    }

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',}}>
                <h3>
                    Contact Settings
                </h3>
                <a href="#" title="" className="btn__delete btn__delete--medium" style={{display: 'inline-block',}} onClick={handleAddressFormCancel} />
            </div>
            <AccountAddressFormBundle onSubmit={handleAddressFormSubmit} address={address} showCloseButton={false} />
        </div>
    );
};

export default AccountSettingAddresses;
